import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import Expander from "../../../../components/Expander";
import { GO_KEYS } from "./constants";

const getGOResultTable = (item) => {
  let goTable = {};
  const goTableBody = [];
  let tableRow = null;
  let tableRowKey = 0;

  for (const key in item) {
    let rowColumn = null;

    if (Array.isArray(item[key]) && item[key].length > 0) {
      rowColumn = (
        <td width="80%">
          <Expander showMore="10">
            {item[key].map((it, i) => {
              return (
                <span key={i}>
                  {it}
                  {i < item[key].length - 1 ? ", " : ""}
                </span>
              );
            })}
          </Expander>
        </td>
      );
    }

    tableRow = (
      <tr key={tableRowKey}>
        <td width="20%"> {GO_KEYS[key]}</td>
        {rowColumn}
      </tr>
    );

    goTableBody.push(tableRow);
    tableRowKey += 1;
  }

  goTable = (
    <table className="varsome-table">
      <tbody>{goTableBody}</tbody>
    </table>
  );

  return goTable;
};

const GoResult = ({ go, gene }) => {
  if (go && Object.keys(go || {}).length > 0) {
    const goUrl = `http://amigo.geneontology.org/amigo/search/bioentity?q=${gene}&searchtype=geneproduct`;
    const table = getGOResultTable(go);
    const goResult = (
      <div className="tw-mt-4">
        <h5>
          <a href={getVarsoUrl(goUrl)} target="_blank">
            Gene Ontology
          </a>
        </h5>
        {table}
      </div>
    );

    return goResult;
  }
  return null;
};

const { string, shape } = PropTypes;

GoResult.propTypes = {
  go: shape({}),
  gene: string,
};

GoResult.defaultProps = {
  go: null,
  gene: null,
};
export default GoResult;
